/** A resource's label for options and chips; never empty, so a nameless resource stays visible. */
export function resourceDisplayName(resource: {
  full_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}): string {
  return (
    resource.full_name?.trim() ||
    [resource.first_name, resource.last_name]
      .map(part => part?.trim())
      .filter(Boolean)
      .join(' ') ||
    'Unnamed resource'
  );
}
